import { TextField } from '@shape-ds/components';
import { Controller, FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormInputProps } from './FormInputProps';
import { useRef } from 'react';

export const FormInput = <T extends FieldValues>({
  name,
  control,
  label,
  placeHolderText,
  isRequired,
  disabled = false,
  readOnly = false,
  defaultValue,
  formatValue,
  rules,
  maxLength,
  classname,
  showErrorMessage = true,
  ...props
}: FormInputProps<T>) => {
  const { t } = useTranslation();
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <Controller
      name={name}
      control={control}
      rules={{ required: isRequired ? t('components:inputs.required_field') : false, ...rules }}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <div className={name}>
          <TextField
            {...props}
            data-testid={name}
            inputRef={inputRef}
            helperText={showErrorMessage && error ? error.message : null}
            required={isRequired}
            label={label}
            placeholder={placeHolderText}
            error={!!error}
            onChange={onChange}
            value={formatValue ? formatValue(value) : value}
            defaultValue={defaultValue}
            fullWidth
            readOnly={readOnly}
            disabled={disabled}
            {...(maxLength && { maxLength })}
            className={`${name.replace(/\./g, '-')} ${classname}`}
            onClickIcon={() => {
              inputRef.current?.focus();
            }}
          />
        </div>
      )}
    />
  );
};
